import { Field } from '@/components/ui/field';
import { Input } from '@chakra-ui/react';
import type { User } from '@fluenceur/types';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';

export function useBillingIdentity(user: User, required: boolean) {
  const { i18n } = useTranslation();
  const [name, setName] = useState(
    [user.firstName, user.lastName].filter(Boolean).join(' ') || user.currentBrand?.name || ''
  );
  const [email, setEmail] = useState(user.email);
  return {
    name,
    email,
    setName,
    setEmail,
    valid:
      !required || (name.trim().length > 0 && z.string().email().safeParse(email.trim()).success),
    identity: {
      name: name.trim(),
      email: email.trim(),
      locale: i18n.language.startsWith('fr') ? ('fr' as const) : ('en' as const),
    },
  };
}

/** The same explicit payer fields serve card saving and a first paid subscription. */
export function BillingIdentityFields({ value }: { value: ReturnType<typeof useBillingIdentity> }) {
  const { t } = useTranslation();
  return (
    <>
      <Field label={t('onboarding.billing.identityName')} required>
        <Input
          value={value.name}
          onChange={(event) => value.setName(event.target.value)}
          variant="outline"
          autoComplete="name"
        />
      </Field>
      <Field label={t('onboarding.billing.identityEmail')} required>
        <Input
          type="email"
          value={value.email}
          onChange={(event) => value.setEmail(event.target.value)}
          variant="outline"
          autoComplete="email"
        />
      </Field>
    </>
  );
}
